import { STOPLIGHT_COLORS } from '../utils/DataFormatterUtils';
import { ENTITY_ADD_REQUEST_STATUSES } from '../types/entity_add_requests';

export { ENTITY_ADD_REQUEST_STATUSES };

export const ENTITY_ADD_REQUEST_STATUS_DISPLAY_NAMES = {
	[ENTITY_ADD_REQUEST_STATUSES.draft]: 'Draft',
	[ENTITY_ADD_REQUEST_STATUSES.pending_review]: 'Pending',
	[ENTITY_ADD_REQUEST_STATUSES.approved]: 'Approved',
	[ENTITY_ADD_REQUEST_STATUSES.rejected]: 'Rejected',
};

export const ENTITY_ADD_REQUEST_STATUS_DISPLAY_TEXT_COLORS = {
	[ENTITY_ADD_REQUEST_STATUSES.draft]: 'rgb(11, 28, 111)',
	[ENTITY_ADD_REQUEST_STATUSES.pending_review]: '#4a1e87',
	[ENTITY_ADD_REQUEST_STATUSES.approved]: STOPLIGHT_COLORS.pureGreen,
	[ENTITY_ADD_REQUEST_STATUSES.rejected]: STOPLIGHT_COLORS.pureRed,
};

export const ENTITY_ADD_REQUEST_STATUS_DISPLAY_BACKGROUND_COLORS = {
	[ENTITY_ADD_REQUEST_STATUSES.draft]: 'rgb(225, 229, 249)',
	[ENTITY_ADD_REQUEST_STATUSES.pending_review]: '#e8def8',
	[ENTITY_ADD_REQUEST_STATUSES.approved]: '#e6f9e7',
	[ENTITY_ADD_REQUEST_STATUSES.rejected]: '#f9e6e6',
};
